import { ProductsComponent } from './products.component';
import { usePagination } from '../shared/usePagination';
import { FilterValue } from 'antd/es/table/interface';
import { QP, useQueryParams } from '../shared/useQueryParams';
import {
  useDeleteProduct,
  useExportProducts,
  useProducts,
  useUpdateProduct,
} from '../utils/api.hook';

const productsQuerySchema = {
  name: QP.string('name'),
  providerIds: QP.stringArray('providerIds'),
  state: QP.stringArray('state'),
  isToppings: QP.boolean('isToppings'),
};

const toStringArray = (
  value: FilterValue | null | boolean | undefined
): string[] | undefined =>
  Array.isArray(value) && value.length ? value.map(String) : undefined;

export function ProductsContainer() {
  const pagination = usePagination({ defaultPageSize: 10, syncUrl: true });
  const { values, setValues } = useQueryParams(productsQuerySchema);
  const { name: keyword, providerIds, state, isToppings } = values;
  const setKeyword = (value: string) => setValues({ name: value });
  const setFilters = (next: Record<string, FilterValue | null | boolean>) =>
    setValues({
      providerIds: toStringArray(next.providerIds),
      state: toStringArray(next.state),
      isToppings:
        typeof next.isToppings === 'boolean' ? next.isToppings : undefined,
    });
  const { mutateAsync: deleteProduct, isLoading: isDeleting } =
    useDeleteProduct();
  const {
    data: { products, providerFilters, total } = {},
    isFetching,
    isLoading,
  } = useProducts({
    providerIds,
    state: state as Parameters<typeof useProducts>[0]['state'],
    isToppings,
    name: keyword,
    take: pagination.take,
    skip: pagination.skip,
  });
  const { mutateAsync: updateProduct, isLoading: isUpdating } =
    useUpdateProduct();
  const { refetch: exportProducts } = useExportProducts();

  return (
    <ProductsComponent
      exportProducts={exportProducts}
      deleteProduct={deleteProduct}
      updateProduct={updateProduct}
      isLoading={isFetching || isLoading || isDeleting || isUpdating}
      products={products || []}
      providerFilters={providerFilters || []}
      setFilters={setFilters}
      setKeyword={setKeyword}
      keyword={keyword}
      filters={{ providerIds, state, isToppings }}
      pagination={{
        ...pagination,
        total,
      }}
    />
  );
}
